import Scroll from './Scroll'

const UA = navigator.userAgent || ''
const iOS = /\b(?:iPhone|iPad|iPod)\b/.test(UA)
const IE11 = /\bTrident\b/.test(UA)
const Edge = /\bEdge\b/.test(UA)
const Chrome = /\bChrome\b/.test(UA)
const Safari = !Edge && !Chrome && /\bSafari\b/.test(UA)

const rootClassList = document.documentElement.classList
if (iOS) rootClassList.add('ios')
if (IE11) rootClassList.add('ie11')
if (Edge) rootClassList.add('edge')
if (Chrome) rootClassList.add('chrome')
if (Safari) rootClassList.add('safari')

// ページ内リンクのスクロール
const scrollManager = (() => {
	if (iOS || IE11 || Edge || Safari) return new Scroll()
	return null
})()

document.addEventListener('click', function (event) {
	const { target } = event
	if (!target.classList.contains('sms')) return

	event.preventDefault()
	const targetE = document.querySelector(target.hash)
	if (!targetE) return

	if (scrollManager) {
		scrollManager.toElement(targetE)
	} else {
		targetE.scrollIntoView({
			behavior: 'smooth',
			block: 'start'
		})
	}
})
